import TermCategoryApi from '@apis/term/TermCategoryApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { TermDisplayContext } from '@models/term/termCategory/common';

const termCategoryQueries = createQueryKeys('termCategories', {
    list: (displayContext: TermDisplayContext) => ({
        queryKey: ['termCategories', displayContext],
        queryFn: () => TermCategoryApi.getTermCategories(displayContext),
    }),
    history: () => ({
        queryKey: ['termCategories', 'history'],
        queryFn: () => TermCategoryApi.getHistoryCategories(),
    }),
});

export default termCategoryQueries;
